import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import FormSection from '../../../../components/atom/FormSection';
import ImageUploader from '../../../../components/atom/ImageUploader';
import { uploadImage } from '../../../../hooks/useSwaggerClient';
import { useNotify } from '../../../../hooks/useNotify';
import FormikInput from '../../../../components/atom/FormikInput';

export default function ClientEditSiteSettings({ values, setFieldValue }) {
    const { notifyInfo } = useNotify();
    return (
        <FormSection title="Site settings">
            <FormikInput name="client_url" label="URL*" type="url" xs={12} sm={12} />
            <Grid item sm={12} xs={12}>
                <TextField
                    label="How many email addresses are shown in the footer"
                    fullWidth
                    type="number"
                    inputProps={{ step: 1, min: 0 }}
                    value={values.contact_email_customer_limit}
                    onChange={ev =>
                        setFieldValue('contact_email_customer_limit', parseInt(ev.target.value, 10))
                    }
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <div>Logo</div>
                <small>Should be a 400x72 transparent png.</small>
                <ImageUploader
                    id="logo"
                    style={{
                        width: 400,
                        height: 72,
                        backgroundColor: values.primaryColor
                    }}
                    image={values.logoImage}
                    uploadImage={async event => {
                        if (!event.target.files || !event.target.files.length) {
                            return;
                        }
                        const f = event.target.files[0];
                        notifyInfo(`Upload started for ${f.name}`);
                        const location = await uploadImage(f);
                        notifyInfo(`Upload finished for ${f.name}`);
                        setFieldValue('logoImage', location);
                    }}
                    removeImage={() => setFieldValue('logoImage', '')}
                    value={values.defaultIsland}
                    setValue={newVal => setFieldValue('defaultIsland', newVal)}
                />
            </Grid>
            <FormikInput sm={3} xs={3} name="primaryColor" label="Primary Color" />
            <FormikInput sm={3} xs={3} name="textColor" label="Text Color" />
            <FormikInput sm={3} xs={3} name="secondaryColor" label="Secondary Color" />
            <FormikInput sm={3} xs={3} name="fontFamily" label="Font" />
        </FormSection>
    );
}
